module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp2_7.14d2aadc.png";